import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client'
import { ApolloLink, from } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory';
import NProgress from 'nprogress'
import store from './config/store'
import router from './router'

// Install the vue plugin
Vue.use(VueApollo)

// Http endpoint
const httpEndpoint = store.api.base

// Interceptors

const middleWare = new ApolloLink((operation, forward) => {
  NProgress.configure({ trickleSpeed: 100, speed: 200 })
  if (!NProgress.isStarted()) {
    NProgress.start()
  }
  return forward(operation).map(response => {
    if (!store.loading) {
      NProgress.done()
    }
    return response
  });
});

// Config
const defaultOptions = {
  httpEndpoint,
  wsEndpoint: null,
  tokenName: store.data.user.access_token || null,
  persisting: false,
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,
  link: from([
      middleWare
  ]),
  cache: new InMemoryCache({freezeResults: false}),
  getAuth: () => 'Bearer ' + store.data.user.access_token
}

// Call this in the Vue app file
export function createProvider (options = {}) {
  // Create apollo client
  const { apolloClient, wsClient } = createApolloClient({
    ...defaultOptions,
    ...options,
  })
  apolloClient.wsClient = wsClient

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        fetchPolicy: 'network-only',
      },
    },
    errorHandler (error) {
      NProgress.done()
      if (error.networkError.statusCode === 401) {
        router.push('/logout')
      }
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
    },
  })

  return apolloProvider
}
